export default __webpack_public_path__ + "static/flag-uganda-02abb0b758160ff55c5293be349cdee5.svg";